import { IPointResponse } from 'dto/pointDto';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import pointService from 'service/point';

export const getUserPoint = createAsyncThunk(
  'point/get',
  async (userId: string, thunkAPI) => {
    try {
      const {
        items,
        error,
        msg,
      }: {
        items: IPointResponse[];
        error: boolean;
        msg: string;
      } = await pointService.getUserPoint(userId);
      return { items, error, msg };
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return {
        items: [],
        error: true,
        msg: thunkAPI.rejectWithValue(message),
      };
    }
  },
);

export interface PointInitType {
  loading: boolean;
  error: boolean;
  errorMsg: any;
  items: IPointResponse[];
}

const initialState: PointInitType = {
  loading: true,
  error: false,
  errorMsg: '',
  items: [],
};

export const pointSlice = createSlice({
  name: 'point',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserPoint.pending, (state, actions) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getUserPoint.fulfilled, (state, actions) => {
      const { items, msg, error } = actions.payload;
      if (error) {
        state.loading = false;
        state.error = true;
        state.errorMsg = msg;
        return;
      }
      state.items = items;
      state.loading = false;
      state.error = false;
    });
    builder.addCase(getUserPoint.rejected, (state, actions) => {
      const { msg }: any = actions.payload;
      state.loading = false;
      state.error = true;
      state.errorMsg = msg;
    });
  },
});

export default pointSlice.reducer;
